import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
var _Asterisk;
/* eslint-disable sort-keys */
import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { DropdownMenu } from '../../DropdownMenu';
import { Icon } from '../../Icon';
import { GRAY400, HelpIconWithTooltip } from '../../common';
import { Asterisk } from '../../common/Astreisk';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function InputSearchInput(props) {
  var destructive = props.destructive,
    disabled = props.disabled,
    _props$enableDropdown = props.enableDropdown,
    enableDropdown = _props$enableDropdown === void 0 ? false : _props$enableDropdown,
    _props$hintCheckbox = props.hintCheckbox,
    hintCheckbox = _props$hintCheckbox === void 0 ? false : _props$hintCheckbox,
    hintText = props.hintText,
    inputValue = props.inputValue,
    label = props.label,
    labelTooltipDescription = props.labelTooltipDescription,
    labelTooltipLabel = props.labelTooltipLabel,
    labelTooltipPlacement = props.labelTooltipPlacement,
    labelTooltipProps = props.labelTooltipProps,
    labelTooltipVariant = props.labelTooltipVariant,
    leadingDropDownMenuOptions = props.leadingDropDownMenuOptions,
    leadingDropDownSelectedOption = props.leadingDropDownSelectedOption,
    onInputClick = props.onInputClick,
    params = props.params,
    placeholder = props.placeholder,
    _props$readOnly = props.readOnly,
    readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
    required = props.required,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    _props$type = props.type,
    type = _props$type === void 0 ? 'default' : _props$type;
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(Stack, {
    "data-element": "Stack",
    "data-component": "InputSearchInput",
    "data-source-file": "InputSearchInput.tsx",
    children: [label && /*#__PURE__*/_jsxs(Stack, {
      alignItems: 'center',
      direction: "row",
      gap: 1,
      sx: {
        marginBottom: '6px'
      },
      children: [/*#__PURE__*/_jsx(Typography, {
        color: theme.palette.gray[700],
        variant: "text-sm-medium",
        children: label
      }), required && (_Asterisk || (_Asterisk = /*#__PURE__*/_jsx(Asterisk, {}))), (labelTooltipLabel || labelTooltipDescription || (labelTooltipProps == null ? void 0 : labelTooltipProps.label) || (labelTooltipProps == null ? void 0 : labelTooltipProps.description)) && /*#__PURE__*/_jsx(HelpIconWithTooltip, {
        tooltipDescription: labelTooltipDescription,
        tooltipLabel: labelTooltipLabel,
        tooltipPlacement: labelTooltipPlacement,
        tooltipProps: labelTooltipProps,
        tooltipVariant: labelTooltipVariant
      })]
    }), /*#__PURE__*/_jsxs(TextFieldContainer, {
      "data-element": "TextFieldContainer",
      "data-source-file": "InputSearchInput.tsx",
      children: [leadingDropDownMenuOptions && leadingDropDownSelectedOption && /*#__PURE__*/_jsx(DropdownMenu, {
        menuItemProps: leadingDropDownMenuOptions,
        menuTriggerProps: {
          buttonText: leadingDropDownSelectedOption,
          disabled: !!params.disabled,
          sx: {
            '&.MuiButton-secondary-gray': {
              borderColor: GRAY400
            }
          },
          triggerType: 'Button'
        }
      }), /*#__PURE__*/_jsxs(InputWrapper, {
        "data-element": "InputWrapper",
        "data-source-file": "InputSearchInput.tsx",
        children: [type !== 'badgeCount' && !enableDropdown && !disabled && /*#__PURE__*/_jsx(Icon, {
          color: theme.palette.gray[500],
          iconId: "SearchLg",
          size: 20,
          sx: {
            marginRight: '8px',
            position: 'absolute',
            zIndex: 1,
            left: '12px',
            top: size === 'medium' ? '12px' : '10px'
          }
        }), /*#__PURE__*/_jsx(StyledTextField, _extends({}, params, {
          InputProps: _extends({}, params.InputProps, {
            onClick: onInputClick,
            readOnly: destructive ? false : readOnly
          }),
          error: destructive,
          helperText: !(leadingDropDownMenuOptions && leadingDropDownSelectedOption) && !hintCheckbox && hintText,
          placeholder: placeholder,
          sx: _defineProperty(_defineProperty(_defineProperty({}, ".MuiOutlinedInput-root", {
            gap: '4px',
            paddingTop: size === 'medium' ? '10px !important' : '8px !important',
            paddingBottom: size === 'medium' ? '10px !important' : '8px !important',
            paddingLeft: type === 'default' && !enableDropdown ? '40px !important' : '14px',
            borderBottomLeftRadius: leadingDropDownMenuOptions ? '0px' : '8px',
            borderTopLeftRadius: leadingDropDownMenuOptions ? '0px' : '8px'
          }), "minWidth", '200px'), "width", '100%'),
          value: inputValue,
          "data-element": "StyledTextField",
          "data-source-file": "InputSearchInput.tsx"
        }))]
      })]
    }), hintText && leadingDropDownMenuOptions && leadingDropDownSelectedOption && !hintCheckbox && /*#__PURE__*/_jsx(Typography, {
      color: destructive ? theme.palette.error[600] : theme.palette.gray[600],
      marginTop: "6px",
      variant: "text-sm-regular",
      children: hintText
    })]
  });
}
var TextFieldContainer = styled(Box)(function (_ref2) {
  var _theme$palette, _theme$palette$gray, _theme$palette2, _theme$palette2$gray;
  var theme = _ref2.theme;
  return _defineProperty(_defineProperty({
    display: 'flex'
  }, ".MuiButton-secondary-gray", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&.Mui-disabled", {
    backgroundColor: theme == null ? void 0 : (_theme$palette = theme.palette) == null ? void 0 : (_theme$palette$gray = _theme$palette.gray) == null ? void 0 : _theme$palette$gray[50]
  }), "borderRadius", '8px'), "borderBottomRightRadius", '0px'), "borderTopRightRadius", '0px'), "border", "1px solid ".concat(theme == null ? void 0 : (_theme$palette2 = theme.palette) == null ? void 0 : (_theme$palette2$gray = _theme$palette2.gray) == null ? void 0 : _theme$palette2$gray[300])), "borderRight", 'none'), "height", '40px'), "outline", 'none')), ".MuiAutocomplete-popupIndicator", {
    padding: '6px',
    transform: 'none'
  });
});
var StyledTextField = styled(TextField)(function (_ref4) {
  var theme = _ref4.theme;
  return _defineProperty({}, ".MuiAutocomplete-input", {
    fontWeight: 400,
    padding: '0px!important'
  });
});
var InputWrapper = styled('div')(function (_ref6) {
  var theme = _ref6.theme;
  return {
    position: 'relative',
    width: '100%'
  };
});